import { useContext, useEffect, useRef, useState } from "react"
import { stateContext } from "./ctx"
import Draggable from "react-draggable";
import {hslaValueChange,placeDragger,getDraggedPixels} from './functions'
const Saturation = () => {
    const [saturation,setSaturation] = useState(100)
    const {schema,setSchema,setSession} = useContext(stateContext)
    const satRef = useRef(null)


    useEffect(()=>{
        const sendSchema = []
        schema.forEach(item=>{
            const newItem = {...item,c:hslaValueChange(item.c,saturation,1)}
            sendSchema.push(newItem)
        })
        setSchema(sendSchema)
    },[saturation])

    const saturationChange = e => setSaturation(getDraggedPixels(e.clientX,satRef.current,100))


    return <div className='flex-1 gap-5 items-center flex'>

            
        <div ref={satRef} className='flex-1 bg-gradient-to-l from-indigo-500 to-white rounded-full w-full h-1 relative'>
            <Draggable onStop={()=>setSession(Date.now())} position={{x:placeDragger(saturation,satRef.current,100),y:0}} axis='x' bounds="parent" onDrag={saturationChange}>
                <div className='handle'></div>
            </Draggable>        
        </div>
        <input type='number' className='input' value={saturation} onChange={e=>console.log(e.target.value)} />

    </div>
}

export default Saturation;